import { all, takeEvery, put, call } from 'redux-saga/effects';
import ApiInstance from 'src/helpers/apiInstance';
import actions from './actions';
import { tableConfig } from '../../../../../settings/index';
import { sendRequest } from '../../../../../helpers/saga';
import { logger } from '../../../../../helpers/logger';
import notifications from '../../../../../redux/notifications/actions';

const api = new ApiInstance('subunits/:id/blocked_workers');
const loadFormDataApi = new ApiInstance('subunits/:id/blocked_workers/form_data');
const unblockWorkerApi = new ApiInstance('subunits/:id/blocked_workers/:talent_id');

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', id } = payload;

    const result = yield call(
      sendRequest,
      api.get,
      { search: { page, pageSize, column, order, filter }, pathParams: { id } },
      notifications.REQUEST_ERROR,
    );

    if (result.status === 200) {
      const { data, totalCount, filteredCount, sortable_columns } = result;

      yield put(
        actions.loadDataSuccess({
          data,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns: sortable_columns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadFormData({ payload }) {
  try {
    const { id } = payload;

    const result = yield call(sendRequest, loadFormDataApi.get, { pathParams: { id } }, notifications.REQUEST_ERROR);

    if (result.status === 200) {
      const { data } = result;

      yield put(actions.loadFormDataSuccess({ data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* addBlockedTalents({ payload }) {
  try {
    const { talents, id } = payload;
    const result = yield call(
      sendRequest,
      api.post,
      { data: { worker_ids: talents.map(talent => talent.key) }, pathParams: { id } },
      notifications.REQUEST_ERROR,
    );

    if (result?.status === 200) {
      yield put(actions.saveSuccess({ data: {} }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* unblockTalent({ payload }) {
  try {
    const { id } = payload;
    const [unitId, talentId] = id;

    const result = yield call(
      sendRequest,
      unblockWorkerApi.delete,
      { pathParams: { id: unitId, talent_id: talentId } },
      notifications.REQUEST_ERROR,
    );

    if (result.status === 200) {
      yield put(actions.unblockTalentSuccess({ id: talentId }));
    }
  } catch (error) {
    logger.error(error);
  }
}

export { loadData };
export { loadFormData };
export { addBlockedTalents };
export { unblockTalent };
export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD, loadData),
    takeEvery(actions.LOAD_FORM_DATA, loadFormData),
    takeEvery(actions.SAVE, addBlockedTalents),
    takeEvery(actions.UNBLOCK_TALENT, unblockTalent),
  ]);
}
